module.exports = __webpack_public_path__ + "img/lingbolive_home@3x.84ce8746.png";